import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Button from "@mui/material/Button";

import aBothOld from "../assets/sounds/old/a_b.wav";
import iBothOld from "../assets/sounds/old/i_b.wav";
import mBothOld from "../assets/sounds/old/m_b.wav";
import sBothOld from "../assets/sounds/old/s_b.wav";
import ssBothOld from "../assets/sounds/old/ss_b.wav";
import uBothOld from "../assets/sounds/old/u_b.wav";
import aLeftOld from "../assets/sounds/old/a_l.wav";
import iLeftOld from "../assets/sounds/old/i_l.wav";
import mLeftOld from "../assets/sounds/old/m_l.wav";
import sLeftOld from "../assets/sounds/old/s_l.wav";
import ssLeftOld from "../assets/sounds/old/ss_l.wav";
import uLeftOld from "../assets/sounds/old/u_l.wav";
import aRightOld from "../assets/sounds/old/a_r.wav";
import iRightOld from "../assets/sounds/old/i_r.wav";
import mRightOld from "../assets/sounds/old/m_r.wav";
import sRightOld from "../assets/sounds/old/s_r.wav";
import ssRightOld from "../assets/sounds/old/ss_r.wav";
import uRightOld from "../assets/sounds/old/u_r.wav";

import aBothNew from "../assets/sounds/new/a_b.wav";
import iBothNew from "../assets/sounds/new/i_b.wav";
import mBothNew from "../assets/sounds/new/m_b.wav";
import sBothNew from "../assets/sounds/new/s_b.wav";
import ssBothNew from "../assets/sounds/new/ss_b.wav";
import uBothNew from "../assets/sounds/new/u_b.wav";
import aLeftNew from "../assets/sounds/new/a_l.wav";
import iLeftNew from "../assets/sounds/new/i_l.wav";
import mLeftNew from "../assets/sounds/new/m_l.wav";
import sLeftNew from "../assets/sounds/new/s_l.wav";
import ssLeftNew from "../assets/sounds/new/ss_l.wav";
import uLeftNew from "../assets/sounds/new/u_l.wav";
import aRightNew from "../assets/sounds/new/a_r.wav";
import iRightNew from "../assets/sounds/new/i_r.wav";
import mRightNew from "../assets/sounds/new/m_r.wav";
import sRightNew from "../assets/sounds/new/s_r.wav";
import ssRightNew from "../assets/sounds/new/ss_r.wav";
import uRightNew from "../assets/sounds/new/u_r.wav";

import Animation from "./Animation";
import QuizPromptImages from "./QuizPromptImages";
import QuizPromptText from "./QuizPromptText";
import QuizFailedAnswer from "./QuizFailedAnswer";
import QuizCorrectAnswer from "./QuizCorrectAnswer";
import DownloadPrompt from "./DownloadPrompt";
import CancelQuizPrompt from "./CancelQuizPrompt";
import NextLevelButton from "./NextLevelButton";

import "../styles/app.css";
import "../styles/home.css";
import "../styles/quiz.css";

const MAX_ROUNDS = 6;
const MAX_ATTEMPTS = 2;

let generatedSound, sideTested, soundToPlay;
var options = [],
  answerList = [],
  currentAnswers = [];

export default function Quiz(props) {
  const [answeredCorrectly, setAnsweredCorrectly] = useState(false);

  const [failedAnswer, setFailedAnswer] = useState(false);

  const [viewDownload, setViewDownload] = useState(false);

  const [viewCancel, setViewCancel] = useState(false);

  const [roundsPlayed, setRoundsPlayed] = useState(0);

  const [usedAttempts, setUsedAttempts] = useState(0);

  const [forestStyle, setForestStyle] = useState("anim move");

  const [robotStyle, setRobotStyle] = useState("robot fly");

  const [poofStyle, setPoofStyle] = useState("robot poof");

  const [backgroundStyle, setBackgroundStyle] = useState("animation-container");

  const [quizStyle, setQuizStyle] = useState("quiz-container");

  const history = useHistory();

  let testFinished =
    roundsPlayed >= MAX_ROUNDS && (answeredCorrectly || failedAnswer);

  const soundList = [
    {
      id: 1,
      name: "a",
      sourceLeft: sourceSelect(aLeftNew, aLeftOld),
      sourceRight: sourceSelect(aRightNew, aRightOld),
      sourceBoth: sourceSelect(aBothNew, aBothOld),
    },
    {
      id: 2,
      name: "i",
      sourceLeft: sourceSelect(iLeftNew, iLeftOld),
      sourceRight: sourceSelect(iRightNew, iRightOld),
      sourceBoth: sourceSelect(iBothNew, iBothOld),
    },
    {
      id: 3,
      name: "m",
      sourceLeft: sourceSelect(mLeftNew, mLeftOld),
      sourceRight: sourceSelect(mRightNew, mRightOld),
      sourceBoth: sourceSelect(mBothNew, mBothOld),
    },
    {
      id: 4,
      name: "s",
      sourceLeft: sourceSelect(sLeftNew, sLeftOld),
      sourceRight: sourceSelect(sRightNew, sRightOld),
      sourceBoth: sourceSelect(sBothNew, sBothOld),
    },
    {
      id: 5,
      name: "š",
      sourceLeft: sourceSelect(ssLeftNew, ssLeftOld),
      sourceRight: sourceSelect(ssRightNew, ssRightOld),
      sourceBoth: sourceSelect(ssBothNew, ssBothOld),
    },
    {
      id: 6,
      name: "u",
      sourceLeft: sourceSelect(uLeftNew, uLeftOld),
      sourceRight: sourceSelect(uRightNew, uRightOld),
      sourceBoth: sourceSelect(uBothNew, uBothOld),
    },
  ];

  function checkAnswer(id) {
    generatedSound.id === id ? correctAnswer(id) : wrongAnswer(id);
  }

  function generateRandomSound() {
    let rand = Math.floor(Math.random() * options.length);
    generatedSound = soundList[options[rand]];
    options.splice(rand, 1);
    chooseSide();
    setRoundsPlayed(roundsPlayed + 1);
  }

  function chooseSide() {
    let side = props.side === 3 ? Math.floor(Math.random() * 3) : props.side;
    switch (side) {
      case 0:
      default:
        soundToPlay = generatedSound.sourceBoth;
        sideTested = "Obe";
        break;
      case 1:
        soundToPlay = generatedSound.sourceLeft;
        sideTested = "Ľavá";
        break;
      case 2:
        soundToPlay = generatedSound.sourceRight;
        sideTested = "Pravá";
    }
  }

  function playSound() {
    soundToPlay.volume = props.volume / 100;
    soundToPlay.play();
  }

  function nextLevel() {
    setQuizStyle("quiz-container");
    setForestStyle("anim move");
    setRobotStyle("robot fly");
    setPoofStyle("robot poof");
    setTimeout(() => {
      setQuizStyle("quiz-container in-front");
      setForestStyle("anim");
      setRobotStyle("robot");
      setPoofStyle("robot");
    }, 7000);
    setTimeout(() => {
      resetState();
      generateRandomSound();
      playSound();
    }, 3000);
  }

  function resetTest() {
    options = [0, 1, 2, 3, 4, 5];
    setAnsweredCorrectly(false);
    setFailedAnswer(false);
    setRoundsPlayed(0);
    setUsedAttempts(0);
    answerList.length = 0;
    currentAnswers.length = 0;
  }

  function resetState() {
    let elements = document.querySelectorAll(".image-list-button");
    elements.forEach((element) => {
      element.removeAttribute("correct");
      element.removeAttribute("wrong");
      element.setAttribute("hoverable", "");
    });
    setAnsweredCorrectly(false);
    setFailedAnswer(false);
    setUsedAttempts(0);
  }

  function correctAnswer(id) {
    let element = document.getElementById(id);
    if (!element.hasAttribute("correct") && !element.hasAttribute("wrong")) {
      element.setAttribute("correct", "");
      element.removeAttribute("hoverable");
    }
    changeCursor();
    currentAnswers[usedAttempts] = id;
    logAnswers(true);
    setAnsweredCorrectly(true);
    currentAnswers.length = 0;
  }

  function wrongAnswer(id) {
    let element = document.getElementById(id);
    if (!element.hasAttribute("correct") && !element.hasAttribute("wrong")) {
      element.setAttribute("wrong", "");
      element.removeAttribute("hoverable");
    }
    setUsedAttempts(usedAttempts + 1);
    currentAnswers[usedAttempts] = id;
    if (usedAttempts === MAX_ATTEMPTS - 1) {
      setFailedAnswer(true);
      logAnswers(false);
      changeCursor();
      currentAnswers.length = 0;
    }
  }

  function changeCursor() {
    let elements = document.querySelectorAll("[hoverable]");
    elements.forEach((element) => {
      element.removeAttribute("hoverable");
    });
  }

  function logAnswers(correctlyAnswered) {
    answerList.push({
      questionId: roundsPlayed,
      sideTested: sideTested,
      soundName: generatedSound.name,
      attemptsCount: usedAttempts + 1,
      answer1: soundList[currentAnswers[0] - 1].name,
      answer2:
        currentAnswers.length === 2
          ? soundList[currentAnswers[1] - 1].name
          : "-",
      finalAnswer: correctlyAnswered ? "Správna" : "Nesprávna",
    });
  }

  function sourceSelect(newSource, oldSource) {
    return new Audio(props.mode === "new" ? newSource : oldSource);
  }

  useEffect(() => {
    resetTest();
    nextLevel();
    setTimeout(() => {
      setBackgroundStyle("animation-container visible");
    }, 100); // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={quizStyle}>
        <QuizPromptImages
          answeredCorrectly={answeredCorrectly}
          failedAnswer={failedAnswer}
          checkAnswer={checkAnswer}
          mode={props.mode}
        />
        <div id="centered-container-bottom" className="centered-container">
          {!answeredCorrectly && !failedAnswer && !testFinished && (
            <QuizPromptText playSound={playSound} />
          )}
          {(answeredCorrectly || failedAnswer) && !testFinished && (
            <>
              {answeredCorrectly && <QuizCorrectAnswer />}
              {failedAnswer && <QuizFailedAnswer />}
              <NextLevelButton nextLevel={nextLevel} />
            </>
          )}
          {!testFinished ? (
            <>
              <Button
                className="outlined-button outlined-button-red"
                variant="outlined"
                onClick={() => {
                  setViewCancel(true);
                }}
              >
                Ukončiť test predčasne
              </Button>
              <CancelQuizPrompt
                viewCancel={viewCancel}
                historyPush={history.push}
                resetTest={resetTest}
                setViewCancel={setViewCancel}
              />
            </>
          ) : (
            <>
              {answeredCorrectly && <QuizCorrectAnswer />}
              {failedAnswer && <QuizFailedAnswer />}
              <Button
                className="outlined-button outlined-button-white"
                variant="outlined"
                onClick={() => {
                  setViewDownload(true);
                }}
              >
                Ukončiť test
              </Button>
              <DownloadPrompt
                viewDownload={viewDownload}
                answerList={answerList}
                resetTest={resetTest}
                historyPush={history.push}
              />
            </>
          )}
        </div>
      </div>
      <Animation
        poofStyle={poofStyle}
        robotStyle={robotStyle}
        forestStyle={forestStyle}
        backgroundStyle={backgroundStyle}
      ></Animation>
    </>
  );
}
